import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ExternalMerchantPasswordrequestPage } from './external-merchant-passwordrequest.page';

const routes: Routes = [
  {
    path: '',
    component: ExternalMerchantPasswordrequestPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ExternalMerchantPasswordrequestPageRoutingModule {}
